<template>

  <div class="w-full duration-500 h-[calc(100vh-37px)] bg-[#F9FBFC] rounded-[30px] py-[11px] sm:py-[22px] ps-[10px] sm:ps-[23px] pe-[10px] sm:pe-[23px] overflow-y-auto scrollbar relative" :class="{ 'xl:ps-[23px] xl:ms-[0]' : isActiveSidebar, 'xl:ms-[-72px] xl:w-[calc(100%-387px)] xl:ps-[100px]' : !isActiveSidebar }">

  <div class="overflow-x-hidden relative w-full scrollbar flex justify-start items-start">

    <div class="duration-500" :class="{ 'w-full xl:w-[calc(100%-424px)] xl:pe-[30px]' : isShorter, 'w-full' : !isShorter }">

    <div class="absolute top-0 left-0 right-0 flex z-15 justify-between items-center">

      <div class="hidden xl:inline-block" v-if="isActiveSidebar">
        <button type="button" class="z-20 border-0 bg-transparent outline-0 p-0 m-0 flex justify-center items-center flex-col bg-[#798B97] w-[72px] h-[64px] rounded-[20px]" id="hamburger" @click="handleSidebar">
          <span class="w-[30px] rounded-[5px] h-[4px] inline-block bg-black mb-[3px]"></span>
          <span class="w-[30px] rounded-[5px] h-[3.5px] inline-block bg-black mb-[3px]"></span>
          <span class="w-[30px] rounded-[5px] h-[4px] inline-block bg-black"></span>
        </button>
      </div>

      <div class="xl:invisible z-[5]">
        <button type="button" class="z-20 border-0 bg-transparent outline-0 p-0 m-0 flex justify-center items-center flex-col bg-[#798B97] w-[72px] h-[64px] rounded-[20px]" id="hamburger" @click="handleSidebar">
          <span class="w-[30px] rounded-[5px] h-[4px] inline-block bg-black mb-[3px]"></span>
          <span class="w-[30px] rounded-[5px] h-[3.5px] inline-block bg-black mb-[3px]"></span>
          <span class="w-[30px] rounded-[5px] h-[4px] inline-block bg-black"></span>
        </button>
      </div>

      <div class="mb-4 xl:mb-0 absolute top-0 end-0 z-40 flex items-center" id="basket">
        <a href="javascript:void(0)" @click="openSettingsModal" class="bg-[#798B97] group cursor-pointer h-[52px] w-[52px] xl:w-[72px] xl:h-[64px] rounded-[20px] outline-0 border-0 flex items-center justify-center hover:bg-[#3E5463] duration-500 group mx-2">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-[38px] h-[38px] xl:w-[42px] xl:h-[42px]">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M14.2788 2.15224C13.9085 2 13.439 2 12.5 2C11.561 2 11.0915 2 10.7212 2.15224C10.2274 2.35523 9.83509 2.74458 9.63056 3.23463C9.53719 3.45834 9.50065 3.7185 9.48635 4.09799C9.46534 4.65568 9.17716 5.17189 8.69017 5.45093C8.20318 5.72996 7.60864 5.71954 7.11149 5.45876C6.77318 5.2813 6.52789 5.18262 6.28599 5.15102C5.75609 5.08178 5.22018 5.22429 4.79616 5.5472C4.47814 5.78938 4.24339 6.1929 3.7739 6.99993C3.30441 7.80697 3.06967 8.21048 3.01735 8.60491C2.94758 9.1308 3.09118 9.66266 3.41655 10.0835C3.56506 10.2756 3.77377 10.437 4.0977 10.639C4.57391 10.936 4.88032 11.4419 4.88029 12C4.88026 12.5581 4.57386 13.0639 4.0977 13.3608C3.77372 13.5629 3.56497 13.7244 3.41645 13.9165C3.09108 14.3373 2.94749 14.8691 3.01725 15.395C3.06957 15.7894 3.30432 16.193 3.7738 17C4.24329 17.807 4.47804 18.2106 4.79606 18.4527C5.22008 18.7756 5.75599 18.9181 6.28589 18.8489C6.52778 18.8173 6.77305 18.7186 7.11133 18.5412C7.60852 18.2804 8.2031 18.27 8.69012 18.549C9.17714 18.8281 9.46533 19.3443 9.48635 19.9021C9.50065 20.2815 9.53719 20.5417 9.63056 20.7654C9.83509 21.2554 10.2274 21.6448 10.7212 21.8478C11.0915 22 11.561 22 12.5 22C13.439 22 13.9085 22 14.2788 21.8478C14.7726 21.6448 15.1649 21.2554 15.3694 20.7654C15.4628 20.5417 15.4994 20.2815 15.5137 19.902C15.5347 19.3443 15.8228 18.8281 16.3098 18.549C16.7968 18.2699 17.3914 18.2804 17.8886 18.5412C18.2269 18.7186 18.4721 18.8172 18.714 18.8488C19.2439 18.9181 19.7798 18.7756 20.2038 18.4527C20.5219 18.2105 20.7566 17.807 21.2261 16.9999C21.6956 16.1929 21.9303 15.7894 21.9827 15.395C22.0524 14.8691 21.9088 14.3372 21.5835 13.9164C21.4349 13.7243 21.2262 13.5628 20.9022 13.3608C20.4261 13.0639 20.1197 12.558 20.1197 11.9999C20.1197 11.4418 20.4261 10.9361 20.9022 10.6392C21.2263 10.4371 21.435 10.2757 21.5836 10.0835C21.9089 9.66273 22.0525 9.13087 21.9828 8.60497C21.9304 8.21055 21.6957 7.80703 21.2262 7C20.7567 6.19297 20.522 5.78945 20.2039 5.54727C19.7799 5.22436 19.244 5.08185 18.7141 5.15109C18.4722 5.18269 18.2269 5.28136 17.8887 5.4588C17.3915 5.71959 16.7969 5.73002 16.3099 5.45096C15.8229 5.17191 15.5347 4.65566 15.5136 4.09794C15.4993 3.71848 15.4628 3.45833 15.3694 3.23463C15.1649 2.74458 14.7726 2.35523 14.2788 2.15224ZM12.5 15C14.1695 15 15.5228 13.6569 15.5228 12C15.5228 10.3431 14.1695 9 12.5 9C10.8305 9 9.47716 10.3431 9.47716 12C9.47716 13.6569 10.8305 15 12.5 15Z"
                  fill="#fff" />
          </svg>
        </a>
        <a class="bg-[#798B97] cursor-pointer h-[52px] w-[52px] xl:w-[72px] xl:h-[64px] rounded-[20px] outline-0 border-0 flex items-center justify-center hover:bg-[#3E5463] duration-500 group" id="cart-btn"  @click="handleCartOpen()">
          <span class="relative">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 33.9" class="w-[30px] h-[24px] xl:w-[38px] xl:h-[33.9px]">
              <path id="Path_2187" data-name="Path 2187" d="M10.985,53.711a1.251,1.251,0,0,1,0-2.5c4.614.016,16.784,0,21.545.008a2.768,2.768,0,0,0,2.709-2.155l2.7-11.706A2.25,2.25,0,0,0,35.759,34.6c-1.915,0-18.172-.074-26.5-.107L7.94,29.6a2.7,2.7,0,0,0-2.6-1.988H1.114a1.114,1.114,0,0,0,0,2.228H5.342a.464.464,0,0,1,.447.341l5.069,18.808a3.477,3.477,0,0,0-3.351,3.536,3.5,3.5,0,0,0,3.478,3.418h1.624a3.9,3.9,0,1,0,7.043,0h7.033A3.9,3.9,0,1,0,33.7,55.88a1.113,1.113,0,0,0-.355-2.169Zm6.817,3.9a1.671,1.671,0,1,1-1.672-1.671h0A1.673,1.673,0,0,1,17.8,57.61Zm12.406,1.67a1.671,1.671,0,0,1-.027-3.341h.054a1.671,1.671,0,0,1-.027,3.341Zm5.559-22.443a.018.018,0,0,1,0,.019l-1.139,4.933H30.775l.657-4.977,4.318.017A.018.018,0,0,1,35.767,36.837ZM24.283,48.99V44.016h3.951l-.656,4.974Zm-5.523,0L18.1,44.016h3.958V48.99Zm-5.128,0h0a.6.6,0,0,1-.581-.444l-1.221-4.53H15.85l.662,4.974Zm4.17-7.2-.67-5.035,4.924.02v5.015Zm6.482,0V36.782l4.9.02-.658,4.986Zm-9.4-5.044.671,5.044H11.226L9.861,36.724ZM32.529,48.99h-2.7l.656-4.974h3.637l-1.05,4.546A.55.55,0,0,1,32.529,48.99Z" transform="translate(0 -27.609)" fill="#fff"/>
            </svg>
            <span class="absolute top-[-6px] end-[-10px] xl:w-[34px] h-6 w-6  xl:h-[34px] rounded-full xl:p-1 bg-[#798B97] group-hover:bg-[#3E5463] duration-500">
              <span class="overflow-hidden w-full h-full text-white rounded-full flex justify-center items-center bg-[#FF7D97] text-[14px] xl:text-[19px] font-medium">
                <span class="mt-[-2px]" id="basketCount"> {{baskets.length}} </span>
              </span>
            </span>
          </span>
        </a>
      </div>

    </div>

    <div class="h-[calc(100vh-90px)] overflow-y-auto scrollbar">

      <!-- slider part -->
      <SliderComponent :isShorter="isShorter" />

      <!-- categories -->
      <CategoriesComponent :branchId="branchId" @setCategoryId="handleCategoryId" :isShorter="isShorter" />

      <!-- product grid -->
      <ProductsComponent :branchId="branchId" :categoryId="categoryId" :isShorter="isShorter" />

    </div>

  </div>

  <div class="w-full sm:w-[424px] duration-500 absolute top-0 z-40" :class="{ 'hidden' : pickUp, '-end-[481px]' : !isShorter, 'end-0' : isShorter }" id="cart">
  <div class="absolute top-[-4px] end-[-4px] z-[99999999]">
    <button type="button" class="border border-[#C1D5E5] flex justify-center items-center rounded-full outline-0 bg-white p-0 m-0 w-[44px] h-[44px]" @click="closeCart()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18.273" height="18.272" viewBox="0 0 18.273 18.272">
        <path id="Path_2192" data-name="Path 2192" d="M10.81,9.272l7.115-7.115A1.184,1.184,0,0,0,16.252.483L9.136,7.6,2.021.483A1.184,1.184,0,0,0,.347,2.157L7.462,9.272.347,16.388a1.184,1.184,0,1,0,1.674,1.674l7.115-7.115,7.115,7.115a1.184,1.184,0,1,0,1.674-1.674Zm0,0" transform="translate(0 -0.136)" fill="#3e5463"/>
      </svg>
    </button>
  </div>
  <!-- cart layout -->
    <template v-if="isCartOpen">
      <CardLayoutComponent @handleOrderComplete="handleOrderComplete" :isCartOpen="isCartOpen" />
    </template>
    <template v-if="orderComplete">
      <OrderCompleteComponent @handleOrderComplete="handleOrderComplete"/>
    </template>
  </div>

  </div>

  <div class="bg-[#F9FBFC] py-[11px] sm:py-[22px] ps-[10px] sm:ps-[23px] pe-[10px] sm:pe-[23px] w-full sm:w-[474px] duration-500 absolute top-0 z-40" :class="{ 'hidden' : !pickUp, '-end-[481px]' : !isShorter, 'end-0' : isShorter }" id="pickup">
    <div class="absolute top-[0] end-[4px] z-[99999999]">
      <button type="button" class="border border-[#C1D5E5] flex justify-center items-center rounded-full outline-0 bg-white p-0 m-0 w-[44px] h-[44px]" @click="closeCart()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18.273" height="18.272" viewBox="0 0 18.273 18.272">
          <path id="Path_2192" data-name="Path 2192" d="M10.81,9.272l7.115-7.115A1.184,1.184,0,0,0,16.252.483L9.136,7.6,2.021.483A1.184,1.184,0,0,0,.347,2.157L7.462,9.272.347,16.388a1.184,1.184,0,1,0,1.674,1.674l7.115-7.115,7.115,7.115a1.184,1.184,0,1,0,1.674-1.674Zm0,0" transform="translate(0 -0.136)" fill="#3e5463"/>
        </svg>
      </button>
    </div>

    <!-- Pickup Page of cart -->
    <PickUpComponent v-if="pickUp" />
  </div>

<!--    settings modal-->
    <template v-if="settingsModal">
      <SettingsModal :settingsModal="settingsModal" @handleCloseModal="handleCloseSettingsModal" />
    </template>

<!--    auth modal-->
    <AuthModal :authModal="authModal" @handleCloseModal="handleCloseAuthModal" />
  </div>

</template>

<script>

import SliderComponent from "@/pages/widgets/SliderComponent.vue";
import CategoriesComponent from "@/pages/widgets/CategoriesComponent.vue";
import ProductsComponent from "@/pages/widgets/ProductsComponent.vue"
import CardLayoutComponent from "@/pages/widgets/CardLayoutComponent.vue";
import OrderCompleteComponent from "@/pages/widgets/OrderCompleteComponent.vue";
import PickUpComponent from "@/pages/widgets/PickUpComponent.vue";
import getUserInfo from "@/utils/getUserInfo";
import ApiService from "@/service/apiService";
import SettingsModal from "@/components/SettingsModal.vue";
import AuthModal from "@/components/AuthModal.vue";

export default {
  name: 'HomePage',
  components: {
    AuthModal,
    SettingsModal,
    CardLayoutComponent,
    SliderComponent, CategoriesComponent, ProductsComponent, OrderCompleteComponent, PickUpComponent
  },
  props: {
    branchId: {
      required: true
    },
    isActiveSidebar: {
      required: true
    }
  },
  data() {
    return {
      isShorter: false,
      pickUp: false,
      isCartOpen: false,
      orderComplete: false,
      categoryId: null,
      baskets: [],
      settingsModal: false,
      userInfo: null,
      authModal: false
    }
  },
  watch: {
    isCartOpen(newValue, oldValue) {
      if (newValue !== oldValue) {
        if(newValue == true || this.orderComplete || this.pickUp){
          this.isShorter = true
        }else {
          this.isShorter = false;
        }
      }
    },
    orderComplete(newValue, oldValue) {
      if (newValue !== oldValue) {
        if(newValue == true || this.isCartOpen || this.pickUp){
          this.isShorter = true
        }else {
          this.isShorter = false;
        }
      }
    },
    pickUp(newValue, oldValue) {
      if (newValue !== oldValue) {
        if(newValue == true || this.orderComplete || this.isCartOpen){
          this.isShorter = true
        }else {
          this.isShorter = false;
        }
      }
    },
  },

  mounted() {
      const userInfo = getUserInfo();
      if(userInfo){
        this.userInfo = userInfo;
      }
      if(this.isCartOpen || this.orderComplete || this.pickUp){
        this.isShorter = true;
      }else {
          this.isShorter = false;
      }
      this.outsideClick();
      this.getBaskets();
  },
  methods: {
    async getBaskets() {
      const userInfo = getUserInfo();
      if (userInfo) {
        try {
          this.basketLoading = true;
          const url = `/payment/get/basket`;
          const response = await ApiService.post(url, {customer_id: userInfo.client.id});
          response.data.data.forEach(each => {
            const basket = each.order_details[0];
            if(basket){
              this.baskets.push(basket);
            }
          })
          if(response?.data?.data?.length > 0){
            localStorage.setItem('baskets', JSON.stringify(response.data.data))
          }else {
            localStorage.removeItem('baskets')
          }
        } catch (error) {
          console.error("Error fetching users:", error);
        } finally {
          this.basketLoading = false;
        }
      }
    },
    handleOrderComplete(status){
      this.orderComplete = status;
      this.isCartOpen = false;
      if(!status){
        this.pickUp = true;
      }
    },

    handleCartOpen() {
      this.isCartOpen = true;
      this.isShorter = true;
    },

    closeCart() {
        this.isCartOpen = false;
        this.orderComplete = false;
        this.pickUp = false;
    },

    handleCategoryId(id){
      this.categoryId = id;
    },

    handleSidebar(){
      this.$emit('handleSidebar');
    },

    outsideClick(){
      window.addEventListener('click', (e) => {
        const cartLayout = document.getElementById('cartLayout');
        const basket = document.getElementById('basket');
        if((cartLayout && !cartLayout.contains(e.target)) && (basket && !basket.contains(e.target))){
          if(this.isCartOpen){
            this.isShorter = false;
            this.isCartOpen = false;
          }
        }
        const orderComplete = document.getElementById('orderComplete');
        if(orderComplete && !orderComplete.contains(e.target)){
          if(this.orderComplete){
            this.isShorter = false;
            this.orderComplete = false;
          }
        }
        const pickup = document.getElementById('pickup');
        if(pickup && !pickup.contains(e.target)){
          if(this.pickUp){
            this.isShorter = false;
            this.pickUp = false;
          }
        }
      })
    },

    openSettingsModal(){
      if(!this.userInfo){
        this.authModal = true;
        return;
      }
      this.settingsModal = true;
    },

    handleCloseSettingsModal(){
      this.settingsModal = false;
    },

    handleCloseAuthModal(){
      this.authModal = false;
    }
  }

}

</script>

<style>
</style>
